import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import {
  isNumberNullOrNegative,
  numberPtBr,
  numberPtBrPercent01,
} from "../../../../main/utils/utils";
import { EmptyTable } from "../../../clients/components/EmptyState";

export default function PerformanceRatioChart(props: {
  prReal: number | undefined;
  prPrevisto: number | undefined;
}) {
  const { prPrevisto, prReal } = props;
  const max = prPrevisto;
  const percentage = (prReal ?? 0) / (max ?? 0);

  const gaugeData = [
    {
      value: percentage,
      name: "Realizada",
      title: {
        fontSize: 16,
        offsetCenter: ["0%", "-10%"],
      },
      detail: {
        fontSize: 20,
        offsetCenter: ["0%", "10%"],
        color: "inherit",
      },
    },
  ];

  const options: EChartsOption = {
    title: {
      text: "Performance Ratio",
      subtext: "Efciência da usina ao converter irradiância solar em energia elétrica útil.",
      subtextStyle: {
        fontSize: 12,
        color: "#aaa",
      },
      textStyle: {
        fontSize: 12,
      },
    },
    backgroundColor: "transparent",
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    series: [
      {
        type: "gauge",
        startAngle: 180,
        endAngle: 0,
        center: ["50%", "65%"],
        radius: "100%",
        min: 0,
        max: 2,
        splitNumber: 3,

        pointer: {
          icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
          length: "55%",
          width: 15,
          offsetCenter: [0, "-35%"],
          itemStyle: {
            color: "#464646",
          },
        },
        axisLine: {
          lineStyle: {
            width: 35,
            color: [
              [0.49, "#ee7d00"], // Abaixo do centro
              [0.51, "#fade0a"], // Centro
              [1, "#fab900"], // Acima do centro
            ],
          },
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },

        axisLabel: {
          show: false,
          distance: 50,
        },

        data: gaugeData,

        title: {
          fontSize: 14,
        },

        detail: {
          fontSize: 12,
          color: "inherit",
          offsetCenter: [0, 0],
          formatter() {
            const vTxt =
              isNumberNullOrNegative(prReal) || (prReal ?? 0) > 1.1
                ? "-"
                : numberPtBr(prReal ?? 0);

            const percentageTxt =
              percentage > 1.5 ? "-" : numberPtBrPercent01(percentage);

            return isNumberNullOrNegative(percentage) || percentage > 1.5
              ? "-"
              : `${vTxt} (${percentageTxt})`;
          },
        },
      },
      {
        type: "gauge",
        startAngle: 180,
        endAngle: 0,
        center: ["50%", "75%"],
        radius: "100%",

        min: 0,
        max: 1,
        splitNumber: 3,

        pointer: {
          show: false,
        },

        progress: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },

        axisLabel: {
          show: false,
          distance: 50,
        },

        title: {
          fontSize: 14,
        },
        detail: {
          width: 100,
          height: 12,
          fontSize: 12,
          color: "inherit",
          borderWidth: 0,
        },
        data: [
          {
            name: "PR Real",
            value: prReal,
            title: {
              fontSize: 14,
              color: "#FFF",
              offsetCenter: ["40%", "15%"],
            },
            detail: {
              fontSize: 14,
              color: "#FFF",
              offsetCenter: ["40%", "30%"],
              formatter(v) {
                const vTxt = numberPtBr(v);
                return isNumberNullOrNegative(v) || v > 1.1 ? "-" : `${vTxt}`;
              },
            },
          },
          {
            name: "PR Previsto",
            value: prPrevisto,
            title: {
              offsetCenter: ["-40%", "15%"],
              fontSize: 14,
              color: "#FFF",
            },
            detail: {
              fontSize: 14,
              color: "#FFF",
              offsetCenter: ["-40%", "30%"],
              formatter(v) {
                const vTxt = numberPtBr(v);
                return `${vTxt}`;
              },
            },
          },
        ],
      },
    ],
  };

  const hasData = prReal || prPrevisto;

  return (
    <>
      {hasData ? (
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "90%",
            width: "100%",
          }}
        >
          <RopChart option={options} />
        </Container>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyTable title="Nenhum dado encontrado!" />
        </Box>
      )}
    </>
  );
}
